<template>
    <div class="indexPage">
        <Header></Header>
        <Navigator></Navigator>
        <div class="indexContainer">
            <router-view />
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/public/Header'
import Footer from '@/components/public/Footer'
import Navigator from '@/components/public/Navigator'

export default {
    components: {
        Header,
        Footer,
        Navigator
    },
    data() {
        return {
            // navIndex: 2
        }
    },
}
</script>

<style scoped lang="less">
.indexPage {

    .indexContainer {
        width: 61.875rem;
        margin: 0 auto;
        margin-bottom: .625rem;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Index.vue